import React from "react";
import "./WhurzIt.css"

const WhurzItTwo = () => (
  <div>

	<h1>Object Oriented Design</h1>
    <p>WhurzIt is an object oriented design.  The item and place classes are created
    using the ES-6 class keyword.</p>

    <p>The item and place classes use the closure of their constructors to make their
    data attributes private.  Because of this, the data attributes are only in scope
    within the object methods of item and place objects.</p>

    

	
  </div>
);

export default WhurzItTwo;


// WEBPACK FOOTER //
// ./src/components/WhurzIt/WhurzItTwo.js